import { createContext, useContext, useEffect, useState } from "react";
import { DICT, LANGS } from "@/lib/i18n";

const LangCtx = createContext(null);
const KEY = "aleph_lang";

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    const saved = localStorage.getItem(KEY);
    return DICT[saved] ? saved : "ar";
  });
  const meta = LANGS.find((l) => l.id === lang);

  useEffect(() => {
    localStorage.setItem(KEY, lang);
    document.documentElement.lang = lang;
    document.documentElement.dir = meta.dir;
  }, [lang, meta]);

  return <LangCtx.Provider value={{ lang, setLang, t: DICT[lang], dir: meta.dir, isRtl: meta.dir === "rtl" }}>{children}</LangCtx.Provider>;
};

export const useLang = () => useContext(LangCtx);
